import { render, staticRenderFns } from "./AdviserSettingsContactInfo.vue?vue&type=template&id=00d85992&"
import script from "./AdviserSettingsContactInfo.vue?vue&type=script&lang=js&"
export * from "./AdviserSettingsContactInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports